import Vue from 'vue'
import Vuex from 'vuex'
import {userKeyT, clientKey,gapeKey, contrataServico, rota, autoKey} from '../global/utils'
Vue.use(Vuex)

export default new Vuex.Store({
    state:{
        isMenuVisible: false,
        isMenuClientVisible: false,
        isEditing: false,
        navSecao: '',
        _content: {},
        user: null,
        client: null,
        gape: null,
        auto: null,
        etapaInicial: 'Inicial',
        contratar:null
    },
    mutations:{
        toggleMenu(state, isVisible){
            if(!state.user){
                state.isMenuVisible = false
                return
            }
            if(isVisible === undefined){
                state.isMenuVisible = !state.isMenuVisible
            }else{
                state.isMenuVisible = isVisible
            }
        },
        editMode(state, isVisible){
            if(isVisible === undefined){
                state.isEditing = !state.isEditing
            }else{
                state.isEditing = isVisible
            }
        },
        navSector(state, nav){
            state.navSecao = nav
        },
        dataContent(state, content){
            if(content != undefined && content != undefined){
                
                state._content = {}
                let dadosObj = JSON.stringify(content);
                let dadosJson = JSON.parse(dadosObj);
                state._content = dadosJson[0]
            }else{
                state._content = {}
            } 
        }, 
        setUser(state, user){
            state.user = user
            if(user){
                localStorage.setItem(userKeyT,user.tokenAuth)
                localStorage.setItem(rota, 'adminpainel')
                state.isMenuVisible = true
            }else{
                localStorage.setItem(userKeyT,null)
                state.isMenuVisible = false
            }

        }, 
        setClient(state, client){
                state.client = client
                if(client){
                    localStorage.setItem(clientKey,client.token)
                    localStorage.setItem(rota, 'areacliente')
                    state.isMenuClientVisible = true
                }else{
                    localStorage.setItem(clientKey,null)
                    state.isMenuClientVisible = false
                }

        }, 
        setGape(state, gape){
                state.gape = gape
                if(gape){
                    localStorage.setItem(gapeKey,gape.token)
                    localStorage.setItem(rota, 'gape')
                    state.isMenugapeVisible = true
                }else{
                    localStorage.setItem(gapeKey,null)
                    state.isMenugapeVisible = false
                }

        }, 
        setAuto(state, auto){
                state.auto = auto
                if(auto){
                    localStorage.setItem(autoKey,auto.token)
                    localStorage.setItem(rota, 'autoespecialistas')
                    state.isMenuautoVisible = true
                }else{
                    localStorage.setItem(autoKey,null)
                    state.isMenuautoVisible = false
                }

        },
        setEtapaInicial(state, etapa){
            state.etapaInicial = etapa
        }, 
        setContratar(state, servico){
            state.contratar = servico
            if(servico){
                localStorage.setItem(contrataServico,servico)
            }else{
                localStorage.setItem(contrataServico,null)
            }

        }
    }
})